import { createFileRoute } from "@tanstack/react-router";
import { OrdersContainer } from "@/features/orders";
import { ordersQueryOptions } from "@/features/orders/hooks";
import { resolveStoreId } from "@/lib/store-loader";

export const Route = createFileRoute("/$store/_layout/orders")({
	loader: async ({ context, params }) => {
		const storeId = await resolveStoreId(context.queryClient, params.store);
		if (!storeId) return;
		await context.queryClient.ensureQueryData(
			ordersQueryOptions(params.store, storeId),
		);
	},
	component: OrdersPage,
});

function OrdersPage() {
	return <OrdersContainer />;
}
